import "./Header.scss";
import { PrimaryBtn } from "../index";
import { images } from "../../utils/images";
import { RiMenu5Fill } from "react-icons/ri";
import { paths } from "../../utils/paths";
import { NavLink } from "react-router-dom";
import { LiaAngleDownSolid } from "react-icons/lia";
import useExecuteContext from "../../utils/hooks/executeContext";

const Header = () => {
  const { menuStatus, setMenuStatus, setShowContact, projectDd, setProjectDd } = useExecuteContext();

  return (
    <header>
      <section className="header_sec">
        <div className="content_wrap">
          <div className="logo_wrap">
            <a href="/">
              <img src={images.logo} alt="Brand Logo" />
            </a>
          </div>

          <nav>
            <NavLink to={paths.HOME}>Home</NavLink>
            <NavLink to={paths.ABOUT}>About</NavLink>
            <div
              className={`dd_wrap ${projectDd ? "active" : ""}`}
              onClick={() => setProjectDd((prev) => !prev)}
            >
              <p>
                Projects <LiaAngleDownSolid />
              </p>         
            </div>
            <NavLink to={paths.EVENTS}>Events</NavLink>
            <NavLink to={paths.LOCATION}>Locations</NavLink>
            <NavLink to={paths.CONTACT}>Contact</NavLink>
          </nav>

          <div className="btn_wrap">
            <PrimaryBtn
              theme="gold"
              title="Inquire now"
              clickHandler={() => setShowContact(true)}
            />
            <button
              type="button"
              className={`menu_btn ${menuStatus ? "open" : ""}`}
              onClick={() => setMenuStatus((prev) => !prev)}
            >
              <RiMenu5Fill />
            </button>
          </div>
        </div>
      </section>
    </header>
  );
};

export default Header;
